














import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      talkTime: {
        H: '1',
        mm: '00',
      },
    };
  },
  created() {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipad') !== -1 || userAgent.indexOf('android') !== -1) {
      // eslint-disable-next-line no-alert
      alert('PC版のGoolge Chromeをお使いください');
    }
    if (userAgent.indexOf('msie') !== -1
        || userAgent.indexOf('trident') !== -1
        || userAgent.indexOf('edg') !== -1) {
      // eslint-disable-next-line no-alert
      alert('PC版のGoolge Chromeをお使いください');
    } else if (userAgent.indexOf('chrome') === -1) {
      // eslint-disable-next-line no-alert
      alert('PC版のGoolge Chromeをお使いください');
    }
  },
});
